//
// GroupingController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./DataDefinitionController";
import "./GroupingInfo";
import "../../models/dataDefinition/DataItem";
import "./ValueGroup";

var GroupingController = createModule("BIRD::GroupingController", ["BIRD::BIRDModelController","BIRD::DataDefinitionController"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        removeGrouping: [0,1],
        getAvailableSourceCategories: [[1]],
        getGroupingForCategory: [1,1],
        getGroupings: [[1]],
        applyGrouping: [0,1],
        getAvailableSourceCategoriesForRemoveGroupsFromSelection: [[1]],
        getAvailableSourceCategoriesForAddGroupFromSelection: [[1]],
        removeGroupsFromSelection: [1,1],
        getValueGroupFromSelection: [1,1],
        getAvailableSourceValues: [[7],1],
        getAvailableSourceValuesForValueGroup: [[7],1,1],
    },
    ,
    ,
]);
export default GroupingController;
